import { render, staticRenderFns } from "./ColorCircle.vue?vue&type=template&id=dfc0429e&scoped=true&"
import script from "./ColorCircle.vue?vue&type=script&lang=js&"
export * from "./ColorCircle.vue?vue&type=script&lang=js&"
import style0 from "./ColorCircle.vue?vue&type=style&index=0&id=dfc0429e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc0429e",
  null
  
)

export default component.exports